import MUIDataTable, { MUIDataTableColumnDef, MUIDataTableOptions } from 'mui-datatables';
import { FunctionComponent } from 'react';
import { useAppTranslate } from '../../../../core/hooks';
import { StatisticsTableChartOptions } from '../../../chart-settings/components';
import { ChartSettingsInteractionModel } from '../../../chart-settings/hooks';
import { SlaMonitoredClassOfServiceViewModel } from '../../model';
import { SlaStatisticsTableRow } from '../SlaStatisticsTableRow/SlaStatisticsTableRow';

interface Props {
  slaMonitoredClassesOfService: SlaMonitoredClassOfServiceViewModel[];
  chartSettingsInteraction: ChartSettingsInteractionModel;
  customerId: number | null;
}

export const SlaStatisticsTable: FunctionComponent<Props> = ({
  slaMonitoredClassesOfService,
  chartSettingsInteraction,
  customerId,
}) => {
  const translate = useAppTranslate();
  const { chartSettings } = chartSettingsInteraction;
  const columns: MUIDataTableColumnDef[] = [
    {
      name: 'serviceName',
      label: translate('tableHeaders.serviceName'),
    },
    {
      name: 'orderNumber',
      label: translate('tableHeaders.soz'),
    },
    {
      name: 'classOfServiceName',
      label: translate('tableHeaders.classOfService'),
    },
    {
      name: 'slaMetrics.delay',
      label: `${translate('tableHeaders.delay')} [${translate('units.millisecond')}]`
    },
    {
      name: 'slaMetrics.jitter',
      label: `${translate('tableHeaders.jitter')} [${translate('units.millisecond')}]`
    },
    {
      name: 'slaMetrics.lossRatio',
      label: `${translate('tableHeaders.lossRatio')} [${translate('units.percent')}]`
    },
  ];

  const options: MUIDataTableOptions = {
    enableNestedDataAccess: '.',
    selectToolbarPlacement: 'none',
    download: false,
    print: false,
    rowHover: false,
    expandableRows: true,
    selectableRows: 'none',
    expandableRowsHeader: false,
    renderExpandableRow: (rowData, rowMeta) =>
      customerId === null
        ? <></>
        : <SlaStatisticsTableRow
            classOfService={slaMonitoredClassesOfService[rowMeta.dataIndex]}
            columnsQuantity={columns.length}
            chartSettings={chartSettings}
            customerId={customerId}
        />
  };

  return <>
    <StatisticsTableChartOptions chartSettingsInteraction={chartSettingsInteraction} />
    <MUIDataTable
      title={''}
      columns={columns}
      data={slaMonitoredClassesOfService}
      options={options}
    />
  </>;
};
